import { Link } from 'react-router-dom';
import './404-error.scss';

const NotFoundError = () => (
    <main className="not-found-page">
        <p className="not-found-page__code">404</p>
        <h1>Page not found</h1>
        <p className="not-found-page__message">
            The page you are looking for may have moved or no longer exists.
        </p>
        <Link className="not-found-page__link" to="/">
            Return to home
        </Link>
    </main>
);

export default NotFoundError;